import React from 'react';
import { Link } from '@/components/LocalizedLink';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { scaleIn, revealOnce } from '@/lib/motion';
import { useLanguage } from '@/hooks/useLanguage';

const WHATSAPP_URL = 'https://wa.me/919284548218?text=Hi%2C%20I%27d%20like%20to%20inquire%20about%20spice%20exports.';

function WhatsAppIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
  );
}

export default function CtaSection({ ctaImg }) {
  const { t } = useLanguage();
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-spice-deep relative overflow-hidden" data-testid="cta-section">
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
        <img src={ctaImg} alt="Request a quote for premium Indian spice powders export" width={1264} height={848} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="relative max-w-3xl mx-auto text-center">
        <motion.div {...revealOnce} variants={scaleIn} transition={{ duration: 0.6 }}>
          <span className="text-xs uppercase tracking-[0.3em] text-saffron-light/70 font-sans font-semibold">{t.cta.subtitle}</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mt-3">
            {t.cta.title1}<br />
            <span className="text-saffron-light">{t.cta.title2}</span>
          </h2>
          <p className="mt-4 text-lg text-cream-muted/70 font-sans">{t.cta.desc}</p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-saffron text-white font-sans font-semibold text-sm px-8 py-4 rounded-md hover:bg-saffron-dark transition-colors shadow-saffron-glow" data-testid="cta-request-quote">
              {t.cta.quote} <ArrowRight size={16} />
            </Link>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-2 border-white/30 text-white font-sans font-semibold text-sm px-8 py-4 rounded-md hover:bg-white/10 transition-colors" data-testid="cta-whatsapp">
              <WhatsAppIcon />
              WhatsApp Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
